import type { CacheBackend } from "@pdfking/compatibility"
import type { TrackingInterface, WireResponse } from "@pdfking/taskmaker"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import type { EngineTasks } from "../types/tasks/EngineTasks"
import { CreateEngine as TaskmakerCreateEngine } from "@pdfking/taskmaker"
import { KeyDrop } from "@pdfking/tfunc"
import { CreateEngineInternal } from "../engine/CreateEngineInternal"
import * as Tasks from "../tasks"

type PdfEngineCreateOptions = Partial<
  {
    readonly cache: CacheBackend<WireResponse[]>
  } & PdfEngineOptions
>

export const CreateEngine = (
  config: PdfEngineCreateOptions = {},
  tracking: TrackingInterface | undefined = undefined
): PdfEngine =>
  CreateEngineInternal(
    TaskmakerCreateEngine<EngineTasks>(Tasks, {
      cache: config.cache,
      tracking,
    }),
    KeyDrop(config, ["cache"])
  )
